var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplogos30For30(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill-rule: evenodd;\n      }\n\n      .st0, .st1 {\n        fill: #0468b1;\n      }\n\n      .st2 {\n        fill: #55bceb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.22,48.65c.44-.08.75-.45,1-.8.24-.33.56-.79.56-1.24,0-.36-.29-.63-.36-1-.16-.84.27-1.44.32-2.17.05-.67-.11-1.31.08-1.93.86-.14.81.95,1.08,1.53.46.15.96.01,1.32.12.54.16.69.76,1.04,1.08.11.82.04,1.87-.28,2.57-.15.32-.53.63-.8.96-1.32,1.63-2.33,3.41-3.73,4.98-.26.29-.54.61-.84.92-.63.64-1.07,1.22-1.4,2.17-.37,1.03-.66,2.18-.96,3.33-.29,1.1-.71,2.21-.88,3.41.59.37,1.26.4,1.85.56,3.05.87,5.69,2.14,8.47,3.45,1.49.7,3.07,1.33,2.81,3.65-.15,1.34-1.15,2.26-1.93,3.17-2.03,2.37-4.49,4.41-6.7,6.62-.41.41-.81.9-1.28,1.4-.42.44-1.18.98-1.28,1.36-.07.27.06.71.04,1-.04.53-.39.96-.36,1.32.03.35.43.92.6,1.28.21.45.35.9.56,1.28.31.55.87,1.25,1.24,1.69.35.41,1.06.58.96,1.32-.13,1-1.77.98-2.69.64-.33-.12-.74-.41-1.08-.6-.37-.21-.82-.42-1.04-.6-.57-.46-1.04-1.38-1.61-1.97-.82-.86-1.78-1.52-2.45-2.29-.32-.37-.84-1.04-.76-1.61.07-.48.67-.75.92-1.12.33-.49.41-.97.92-1.16.1-.05.54.06.76,0,.31-.09.81-.84,1.08-1.16.4-.47.73-.84,1.04-1.2,1.45-1.69,2.15-3.58,3.13-5.86.29-.68.85-1.34,1.4-1.97.12-.13.47-.54.4-.72-.1-.26-1.69-.1-2.09-.08-1.44.09-3.29.43-4.9.24-.99,1.01-1.6,2.43-2.41,3.73-.39.63-.81,1.25-1.2,1.89-.57.91-.99,1.79-1.61,2.61-.17.23-.31.51-.48.68-.17.18-.48.33-.72.52-.23.19-.43.45-.64.56-.5.25-1.16.33-1.73.56-1.23.51-2.14,1.39-3.21,2.25-1.45,1.16-2.88,2.28-4.37,3.41-.76.58-1.61,1.05-2.25,1.65-.3.28-.64.77-1,1.2-.35.42-.79.85-1,1.2-.42.69-.8,1.5-1.24,2.29-.39.7-1.07,1.79-1.16,2.53-.05.42-.02,1.12,0,1.73.02.54.16,1.28-.04,1.61-.08.13-.66.42-1,.32-.3-.08-.92-1.31-1.04-1.61-.48-1.12-.47-2.69-.6-4.37-.08-1.06-.25-2.16-.32-3.13-.06-.89-.13-1.89.16-2.57,1.13-.38,2.34-.25,3.37-.72.84-.38,1.87-1.59,2.49-2.29.37-.42.75-.84,1.12-1.24.39-.42.85-.82,1.12-1.24.23-.36.35-.73.6-1.04.66-.81,1.51-1.83,2.41-2.45.63-.43,1.37-.78,2.05-1.16.66-.37,1.24-.85,1.97-1.2-.04-.74.53-1.15.68-1.69.22-.77.06-1.72.2-2.61.12-.81.34-1.68.6-2.45.26-.78.66-1.59.76-2.29.13-.89-.13-1.84-.24-2.53-.26-1.65.18-2.86.64-4.05.5-1.29,1.07-2.45,1.08-4.21.01-1.45-.17-3.11-.28-4.7-.14-1.97-.38-3.92-.56-6.1-.06-.7-.09-1.84-.36-2.01-.28-.17-1.01-.06-1.48-.04-1.06.04-2.06.08-3.09.08-.52,0-1.14-.08-1.4,0-.25.07-.59.7-.8,1-1.25,1.73-2.56,3.58-3.37,5.66-.38.99-1.09,2.17-.88,3.37.11.66.67,1.18.6,1.93-.01.13-.14.41-.24.64-.19.41-.36.87-.72,1.08-.17.1-.43.06-.6.16-.32.2-.26.67-.8.68-.36,0-.36-.08-.56-.28-.27-.02-.53-.06-.72-.16-.09-.46-.27-.83-.72-.92.2-.45-.37-.75-.4-1.16-.05-.56.36-1.35.68-1.85.35-.54.83-.82,1.08-1.48.16-.43.28-.97.4-1.44.39-1.49.7-2.88,1.24-4.29.73-1.89,1.48-3.6,2.21-5.14.71-.86,1.87-1.3,3.09-1.81,1.38-.57,3.01-1.09,4.58-1.48.34-.09.71-.07,1.04-.16.62-.17,1.23-.73,1.85-.92.98-.31,2.18.09,3.29,0,.7-.05,2.02-.63,2.29-1.2.21-.45.14-1.1.04-1.65-.22-1.26-1.35-2.85-.76-4.41.08-.2.29-.41.44-.64.58-.92,1.16-1.79,2.53-1.93.64-.07,1.47.16,2.17.28,1.1.19,2.03.49,2.65,1.16.56.61.77,1.5,1.04,2.45.05.18.25.47.24.64-.03.41-.6.43-.6.92,0,.63,1.01.67.96,1.32-.02.34-.2.16-.32.44.29.49-.12.83,0,1.36-.46.28-.52.98-.76,1.48-.43.19-1.11-.02-1.73.24-.25.11-.99.62-.88.96.07.22.97.3,1.24.44,1.05.54,1.24,1.84,1.44,3.37.1.73.25,1.48.24,2.09,0,.65-.18,1.26-.28,1.85-.1.54-.41,1.13-.16,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.39,59.49c1.24.53,1.88.83,2.45,1.69,1.4,2.09.7,5.45-.16,7.38-.99,2.23-2.36,3.75-4.01,5.14-1.51,1.27-3.6,2.6-6.02,3.13-2.78.61-5.54.03-6.74-1.85-.87-1.35-.92-3.76-.2-5.42.54-1.24,1.91-2.96,3.89-2.73,1.59.19,2.21,2.09,1.44,3.61-.64,1.27-2.21,2.01-2.49,3.37-.25,1.21.42,1.79,1.48,1.89,2,.19,3.41-.84,4.45-1.81,1.14-1.05,1.91-2.29,2.65-3.61.97-1.74,2.29-4.23,2.49-6.9.08-1.03-.06-2.24-.64-2.45-.64-.22-1.41.26-1.81.52-.53.34-.87.83-1.53.8-.39-.7.19-1.3.64-1.69.47-.4,1.09-.74,1.57-1.04,2.03-1.29,4.06-3,5.26-5.26.63-1.19,1.76-4.52-.08-5.18-1.02-.36-2.22.19-2.89.52-1.51.76-2.6,2.12-3.25,3.85-.32.85-.63,1.9-.6,2.93.01.41.47,1.21.08,1.44-.76.46-1.21-1.04-1.28-1.4-.5-2.57.96-4.76,2.01-6.02,1.6-1.92,4.02-3.6,7.26-3.81,2.28-.15,3.7,1.15,3.85,3.17.22,2.85-1.2,4.8-2.61,6.18-1.51,1.48-3.35,2.57-5.22,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.66,46.93c-.14.24-.12.62-.28.84-.17.22-.66.41-.92.64-1.59,1.38-2.95,3.4-4.17,5.26-2.47,3.73-4.81,7.73-6.5,12.28-.42,1.14-.8,2.26-1.12,3.57-.41,1.66-1.32,5.79.84,5.98.43.04.88-.11,1.2-.24,1.38-.58,2.41-1.92,3.33-3.13,2.73-3.6,5.24-8.22,6.9-12.48.85.16,1.47-.24,1.77-.76.89-.19,1.15-.82,1.52-1.61.27-.55.37-1.12.16-1.85-.13-.46-.44-.86-.48-1.28-.08-.89.48-1.88.76-2.61.32-.83.7-1.5,1.08-2.25,1.51,3.95-.08,8.45-1.36,11.52-1.39,3.32-3.17,6.32-5.18,8.99-1.91,2.54-4.3,5.33-7.46,6.7-1.89.82-4.02.79-5.42-.44-3.18-2.8-1.53-9.78-.12-13.4.96-2.47,2.03-4.48,3.37-6.54,1.89-2.91,4.24-5.64,7.3-7.59,1.01-.64,2.17-1.31,3.33-1.61.42-.11.97-.15,1.44,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.2,48.61c3.66-.34,5.92,1.75,7.3,3.89,1.39,2.17,2.35,5.43,2.49,8.71.15,3.53-.63,6.77-1.97,9.23-1.33,2.44-3.5,4.51-6.42,4.74-3.69.29-5.89-1.72-7.3-3.89-2.21-3.4-3.2-8.7-2.05-13.81.35-1.56.86-2.9,1.49-4.09,1.2-2.29,3.23-4.48,6.46-4.78ZM181.51,57.04c-1.01,2.95-.96,7.4.2,10.31.54,1.36,1.48,2.9,2.89,3.09,1.22.16,1.96-.57,2.49-1.24,2.36-3.01,2.46-10.42.44-13.93-.56-.98-1.5-2.1-2.93-1.89-1.64.25-2.57,2.12-3.09,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.68,59.53c2.41,1.28,4.37,3.3,4.37,6.78,0,3.32-1.58,5.7-3.73,7.18-2.11,1.45-5.52,2.21-8.79,1.2.97-1.34,2.37-2.23,2.69-4.21,2.9.13,4.66-1.55,4.66-4.13,0-2.07-1.55-3.7-3.93-3.53-.95.07-1.63.48-2.45.76-.6-.58-1.05-1.36-1.61-2.13-.19-.26-.5-.48-.4-.76.07-.21.83-.54,1.08-.68,2.55-1.48,5.07-3.37,6.3-5.98-2.28-.07-4.66-.04-7.18-.04-.62,0-2.04.17-2.33-.08-.31-.26-.12-2.62-.12-3.41,0-.49-.11-1.08.24-1.2.38-.14,1.35,0,1.89,0h11.32c.59,0,1.56-.08,1.77.12.25.25.15,1.93.12,2.37-.12,1.63-.76,3.12-1.44,4.37-.71,1.29-1.51,2.39-2.45,3.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "164.38 84.27 164.37 81.54 166.46 81.53 166.45 80.46 164.37 80.47 164.37 78.88 167 78.88 167 77.79 163.05 77.8 163.06 84.28 164.38 84.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 168.39,
    y: 77.79,
    width: 1.32,
    height: 6.48,
    transform: "translate(-.11 .24) rotate(-.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "170.79 77.79 170.79 78.86 173.22 78.86 173.23 84.26 174.56 84.26 174.55 78.85 176.99 78.85 176.99 77.78 170.79 77.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "182.66 77.77 182.67 81.31 178.89 77.78 178.01 77.78 178.02 84.26 179.34 84.25 179.33 79.76 182.67 82.88 182.67 84.25 183.99 84.25 183.98 77.77 182.66 77.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "187.11 83.16 187.1 81.51 189.25 81.5 189.25 80.43 187.1 80.43 187.1 78.85 189.97 78.85 189.97 77.76 185.78 77.77 185.79 84.24 190.14 84.24 190.14 83.16 187.11 83.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.41,80.75l-1.12-.65c-.37-.21-.73-.44-.73-.77,0-.34.33-.68.95-.69.76,0,1.6.35,1.89.49v-1.15c-.21-.09-.92-.42-1.89-.42-1.22,0-2.26.64-2.26,1.77,0,.99.71,1.44,1.4,1.85l1.12.64c.37.22.72.46.72.77,0,.35-.39.73-1.19.73-.85,0-1.83-.5-2.13-.65v1.2c.32.14,1.09.56,2.16.56,1.36,0,2.48-.69,2.48-1.87,0-.99-.89-1.52-1.39-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.08,80.75l-1.12-.65c-.37-.2-.73-.44-.73-.77,0-.34.33-.68.95-.69.76,0,1.6.35,1.89.49v-1.15c-.21-.09-.92-.42-1.89-.42-1.22,0-2.26.64-2.26,1.77,0,.99.71,1.44,1.4,1.85l1.12.64c.37.22.72.46.72.77,0,.35-.39.73-1.19.73-.85,0-1.83-.5-2.13-.65v1.2c.32.14,1.09.56,2.16.56,1.36,0,2.48-.69,2.48-1.87,0-.99-.89-1.52-1.39-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.03,90.27c-1.05,0-1.95-.75-1.96-1.8,0-1.06.95-1.81,2.03-1.81.85,0,1.58.35,1.78.45v-.94c-.19-.07-.86-.34-1.91-.34-1.59,0-3,1.11-3,2.66,0,1.55,1.43,2.63,3.01,2.63,1.12,0,1.73-.28,1.91-.35v-.92c-.22.08-.93.43-1.86.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "171.46 85.96 171.46 88.02 168.99 88.03 168.99 85.96 167.97 85.96 167.98 90.96 168.99 90.96 168.99 88.85 171.46 88.84 171.46 90.95 172.48 90.95 172.47 85.96 171.46 85.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.32,85.95l-2.06,5h1.05s.53-1.41.53-1.41h1.8s.54,1.4.54,1.4h1.08s-2.07-4.99-2.07-4.99h-.87ZM175.12,88.81l.63-1.66.63,1.66h-1.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "180.07 90.11 180.07 85.95 179.05 85.95 179.06 90.94 182.8 90.94 182.79 90.11 180.07 90.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "184.6 90.11 184.59 85.94 183.58 85.94 183.58 90.94 187.32 90.93 187.32 90.1 184.6 90.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "189.12 90.09 189.12 88.82 190.77 88.82 190.77 87.99 189.12 87.99 189.12 86.77 191.33 86.77 191.33 85.93 188.1 85.94 188.11 90.93 191.46 90.92 191.46 90.09 189.12 90.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "196.13 85.93 196.14 88.65 193.22 85.93 192.54 85.93 192.55 90.92 193.57 90.92 193.56 87.46 196.14 89.86 196.14 90.92 197.15 90.92 197.15 85.92 196.13 85.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.13,88.52v1.6c-.28.06-.55.1-.84.1-1.05,0-1.95-.75-1.96-1.8,0-1.06.95-1.81,2.03-1.81.64,0,1.22.19,1.78.45v-.94c-.19-.07-.86-.34-1.91-.34-1.59,0-3,1.11-3,2.66,0,1.55,1.43,2.63,3.01,2.63,1.12,0,1.73-.28,1.91-.35v-2.19s-1.02,0-1.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "207.8 90.07 205.46 90.07 205.46 88.8 207.11 88.79 207.11 87.97 205.46 87.97 205.46 86.75 207.67 86.74 207.67 85.91 204.44 85.91 204.45 90.91 207.8 90.9 207.8 90.07"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.53,64.17h1.12v-1.37h.75v1.37h1.93v.87h-4.56v-2.6h.76v1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.47,59.52c0,1.47-1.08,2.56-2.42,2.56s-2.42-1.09-2.42-2.56,1.08-2.57,2.42-2.57,2.42,1.09,2.42,2.57ZM135.4,59.52c0,.96.74,1.67,1.65,1.67s1.65-.71,1.65-1.67-.74-1.68-1.65-1.68-1.65.71-1.65,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.41,53.21c0,.47-.18.71-.66,1.03l-1.16.76v.23h1.74v.87h-4.56v-1.36c0-1.04.52-1.64,1.34-1.64.74,0,1.16.61,1.36.97l1.01-.7c.18-.12.28-.23.28-.4,0-.14-.1-.23-.19-.32l.31-.31c.08.06.53.31.53.86ZM135.53,54.74v.49h1.35v-.39c0-.47-.3-.87-.71-.87s-.64.27-.64.77Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.08,28.74c-2.34,0-4.08-1.72-4.08-3.85s1.74-3.85,4.08-3.85,4.09,1.73,4.09,3.85-1.74,3.85-4.09,3.85ZM99.08,22.27c-1.52,0-2.66,1.18-2.66,2.63s1.14,2.63,2.66,2.63,2.67-1.18,2.67-2.63-1.14-2.63-2.67-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.72,28.53h-2.43v-7.26h2.36c2.13,0,4.23,1.3,4.23,3.65s-2.04,3.6-4.17,3.6ZM107.7,22.48h-1.02v4.8h1.07c1.58,0,2.71-.89,2.71-2.36s-1.19-2.44-2.76-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.01,28.53v-7.26h4.39v1.21h-3.01v1.78h2.25v1.2h-2.25v1.85h3.18v1.21h-4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.54,28.74c-1.12,0-1.93-.47-2.26-.63v-1.34c.32.17,1.34.73,2.24.73.84,0,1.25-.42,1.25-.82,0-.36-.37-.63-.75-.87l-1.18-.72c-.73-.46-1.47-.96-1.47-2.07,0-1.27,1.1-1.98,2.38-1.98,1.02,0,1.76.37,1.98.47v1.29c-.31-.15-1.19-.55-1.98-.55-.65,0-1,.38-1,.77s.38.64.77.87l1.18.73c.52.32,1.46.91,1.46,2.02,0,1.33-1.18,2.1-2.61,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.12,28.74c-1.12,0-1.93-.47-2.26-.63v-1.34c.32.17,1.34.73,2.24.73.84,0,1.25-.42,1.25-.82,0-.36-.37-.63-.75-.87l-1.18-.72c-.73-.46-1.47-.96-1.47-2.07,0-1.27,1.1-1.98,2.38-1.98,1.02,0,1.76.37,1.98.47v1.29c-.31-.15-1.19-.55-1.98-.55-.65,0-1,.38-1,.77s.38.64.77.87l1.18.73c.52.32,1.46.91,1.46,2.02,0,1.33-1.18,2.1-2.61,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.38,28.53l-.73-2.04h-2.45l-.73,2.04h-1.43l2.81-7.26h1.19l2.81,7.26h-1.47ZM136.42,23.01l-.86,2.41h1.71l-.86-2.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.55,36.4c-1.86,0-3.55-1.37-3.55-3.32s1.67-3.35,3.55-3.35c1.24,0,2.03.34,2.25.43v1.19c-.24-.12-1.11-.56-2.1-.56-1.27,0-2.39.94-2.39,2.28s1.06,2.27,2.3,2.27c1.1,0,1.94-.44,2.19-.54v1.16c-.21.09-.93.44-2.25.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.66,36.4c-2.03,0-3.54-1.5-3.54-3.34s1.51-3.34,3.54-3.34,3.54,1.5,3.54,3.34-1.51,3.34-3.54,3.34ZM105.66,30.78c-1.32,0-2.3,1.02-2.3,2.28s.99,2.28,2.3,2.28,2.32-1.02,2.32-2.28-.99-2.28-2.32-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.04,36.21v-6.29h1.2v5.25h3.21v1.04h-4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.94,36.21v-6.29h1.2v5.25h3.21v1.04h-4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.83,36.21v-6.29h3.81v1.05h-2.61v1.54h1.95v1.04h-1.95v1.61h2.76v1.05h-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.56,36.4c-1.86,0-3.55-1.37-3.55-3.32s1.67-3.35,3.55-3.35c1.24,0,2.03.34,2.25.43v1.19c-.66-.32-1.35-.56-2.1-.56-1.27,0-2.39.94-2.39,2.28s1.06,2.27,2.31,2.27c.34,0,.67-.04,1-.12v-2.02h1.2v2.76c-.21.09-.93.44-2.25.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.89,36.21v-6.29h3.81v1.05h-2.61v1.54h1.95v1.04h-1.95v1.61h2.76v1.05h-3.96Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 140.48,
    width: 1.77,
    height: 6.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 144.69,
    y: 2.98,
    width: 2.47,
    height: 0.71,
    transform: "translate(127.1 148.08) rotate(-83.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 149.21,
    y: 3.69,
    width: 2.47,
    height: 0.71,
    transform: "translate(115.41 150.41) rotate(-78.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "154.82 6.51 154.15 6.29 154.91 3.94 155.58 4.16 154.82 6.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 157.9,
    y: 6.51,
    width: 2.47,
    height: 0.71,
    transform: "translate(88.21 149.49) rotate(-66.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 165.81,
    y: 11.08,
    width: 2.47,
    height: 0.71,
    transform: "translate(59.49 139.76) rotate(-53.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 169.37,
    y: 13.96,
    width: 2.47,
    height: 0.71,
    transform: "translate(45.81 131.52) rotate(-48)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "173.15 18.64 172.68 18.11 174.52 16.46 174.99 16.98 173.15 18.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "175.92 22.11 175.51 21.54 177.5 20.09 177.92 20.66 175.92 22.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 180.05,
    y: 28.66,
    width: 2.47,
    height: 0.71,
    transform: "translate(3.91 76.38) rotate(-24.04)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "181.85 34 181.63 33.33 183.99 32.56 184.2 33.23 181.85 34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "182.97 38.3 182.82 37.61 185.24 37.1 185.39 37.79 182.97 38.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 183.58,
    y: 41.86,
    width: 2.47,
    height: 0.71,
    transform: "translate(-3.32 18.92) rotate(-5.81)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "110.05 18.11 109.58 18.64 107.74 16.98 108.21 16.46 110.05 18.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "113.22 15 112.69 15.47 111.04 13.63 111.56 13.16 113.22 15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 115.33,
    y: 10.2,
    width: 0.71,
    height: 2.47,
    transform: "translate(15.3 70.06) rotate(-35.93)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "124.42 7.85 123.77 8.14 122.77 5.88 123.41 5.6 124.42 7.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "128.58 6.3 127.91 6.51 127.14 4.16 127.81 3.94 128.58 6.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 131.93,
    y: 2.81,
    width: 0.71,
    height: 2.47,
    transform: "translate(2.02 27.42) rotate(-11.92)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "137.28 4.52 136.57 4.59 136.32 2.14 137.02 2.06 137.28 4.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 118.89,
    y: 6.74,
    width: 1.26,
    height: 4.41,
    transform: "translate(11.52 60.91) rotate(-29.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 177,
    y: 24.31,
    width: 4.41,
    height: 1.26,
    transform: "translate(11.47 92.78) rotate(-29.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 161.01,
    y: 8.31,
    width: 4.41,
    height: 1.26,
    transform: "translate(73.9 145.84) rotate(-60.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 181.97,
    y: 45.9,
    width: 6.18,
    height: 1.77
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.61,51.22c-.1-.22-.23-.42-.41-.6-.17-.17-.38-.31-.6-.4-.23-.1-.48-.15-.74-.15s-.5.05-.74.15c-.23.09-.43.23-.6.4-.17.17-.31.37-.41.6-.1.23-.15.48-.15.73s.05.5.15.73c.1.22.23.42.41.6.17.17.38.31.6.4.23.1.48.15.74.15s.5-.05.74-.15c.23-.09.43-.23.6-.4.17-.17.31-.37.41-.6.1-.23.15-.48.15-.73s-.05-.5-.15-.73ZM197.86,53.44c-.83,0-1.51-.67-1.51-1.49s.68-1.49,1.51-1.49,1.51.67,1.51,1.49-.68,1.49-1.51,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.59,52.27c-.06-.12-.14-.23-.24-.3.23-.11.34-.29.34-.53,0-.2-.09-.35-.26-.47-.17-.11-.4-.17-.68-.17-.19,0-.4.02-.64.06h-.03v2.15h.38v-.92h.35c.15,0,.26.07.36.21.1.15.17.37.21.67v.03h.39v-.04c-.06-.32-.12-.56-.19-.7ZM197.8,51.79h-.34v-.65c.08,0,.17,0,.28,0,.38,0,.57.11.57.33s-.17.33-.51.33Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplogos30For30);
export default __webpack_public_path__ + "static/media/APP LOGOS_30FOR30.f4901657b93d9277f1568fdbcaa677c8.svg";
export { ForwardRef as ReactComponent };